import React from "react";
import Axios from "axios";
import { BlockSquare } from "../../components/common/StyledComponents";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../helpers/AsyncMessage";
import {
  antdMessageError,
  buildErrorObject,
  errorHandler,
  prettyDateFormat,
} from "../../helpers/Utils";

export const getPrisyncs =
  (page, filterParams, type = "Prisync") =>
  async (dispatch, getState) => {
    let cancel;
    try {
      dispatch({ type: "ONLY_LOADING_CUSTOM" });

      const { data } = await Axios({
        method: "GET",
        url: `/api/v1/prisyncs.json?page=${page}&per_page=${
          type == "Prisync" ? 250 : 9999
        }${filterParams}`,
        cancelToken: new Axios.CancelToken((c) => (cancel = c)),
      });

      const full_data = [...getState().custom.data, ...data.data];
      const full_data_ids = [...new Set(full_data.map((d) => d.id))];
      const full_filtered = full_data_ids.map((d) =>
        full_data.find((s) => s.id == d)
      );

      console.log(data.last_sync);

      dispatch({
        type: "GET_CUSTOMS",
        payload: {
          ...data,
          data: full_filtered,
          current: type,
          show_data: {
            last_sync: data.last_sync ? prettyDateFormat(data.last_sync) : "",
          },
        },
      });
      return { success: true, has_more: data.data.length == 0 ? false : true };
    } catch (err) {
      errorHandler(err);
      if (Axios.isCancel(e)) return;
      antdMessageError();
      return { success: false };
    }
  };

export const getPrisyncsOptions = () => async (dispatch) => {
  try {
    const { data } = await Axios.get(`/api/v1/prisyncs/prisync_shops`);
    const { data: prisync_product_tags } = await Axios.get(
      `/api/v1/prisync_product_tags`
    );

    if (!data.success) return;
    // console.log(data.data);
    dispatch({
      type: "SET_OPTIONS",
      payload: {
        shops: data.data.map((d) => ({
          value: d,
          label: d,
        })),
        prisync_product_tags: prisync_product_tags.map((d) => ({
          value: d.id,
          label: d.title,
          color: d.color,
          preview: (
            <div className="d-flex align-items-center">
              <div className="mr-1">
                <BlockSquare color={d.color} />
              </div>
              {d.title}
            </div>
          ),
        })),
      },
    });
    return { success: true };
  } catch (err) {
    console.log("ERROR ", err);
    return { success: false };
  }
};

export const rollbackPrisyncToPim = async (id) => {
  try {
    const { data } = await Axios.post(`/api/v1/prisyncs/rollback_pim?id=${id}`);
    antdAsyncMessageLoading({ key: "export_to_pim" });

    if (!data.success) throw new Error("ERR");

    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key: "export_to_pim" });
    return { success: false };
  }
};

export const exportPrisyncToAlso =
  (lang, type, ids, filterString) => async (dispatch) => {
    const key = "exportPrisyncToAlso";
    try {
      antdAsyncMessageLoading({ key: "export_to_pim", text: "Sent to import" });

      const { data } = await Axios.post(
        `/api/v1/prisyncs/export_to_pim?${filterString}`,
        {
          all: type == "all" ? true : false,
          ids,
          lang,
        }
      );
      if (!data.success) throw new Error("ERR");

      setTimeout(() => {
        antdAsyncMessageSuccess({ key: "export_to_pim" });
      }, 3000);
      return { success: true };
    } catch (err) {
      errorHandler(err);
      // antdMessageError();
      antdAsyncMessageError({ key: "export_to_pim" });

      return { success: false };
    }
  };

export const prisyncMassChangePriceToOldPrice = async (lang, ids) => {
  const key = "mass_change_price";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post(`/api/v1/prisyncs/mass_change_price`, {
      ids,
      lang,
    });
    if (!data.success) throw new Error("ERR");
    return { success: true };
  } catch (err) {
    antdAsyncMessageError({ key });
    errorHandler(err);
    return { success: false };
  }
};

export const prisyncDisableChannelPriceScope = async (lang, ids) => {
  const key = "disable_channel_price_scope";
  try {
    antdAsyncMessageLoading({ key });
    const { data } = await Axios.post(
      `/api/v1/prisyncs/disable_channel_price_scope`,
      {
        ids,
        lang,
      }
    );
    if (!data.success) throw new Error("Operation failed");
    if (data.success) antdAsyncMessageSuccess({ key });
    return { success: true };
  } catch (err) {
    antdAsyncMessageError({ key });
    errorHandler(err);
    return { success: false };
  }
};

export const getPrisyncXls = async (params) => {
  try {
    antdAsyncMessageLoading({
      key: "exportDocument",
      text: <span id="prisync_xlsx_progress">In progress...</span>,
    });
    const { data } = await Axios.post(
      `/api/v1/prisyncs/get_xls?${params?.filter || ""}`,
      params
    );
    if (!data.success) throw new Error("ERR");
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key: "exportDocument" });
  }
};

export const putPrisyncs =
  (id, prisync, parent_id, related_ids) => async (dispatch) => {
    try {
      antdAsyncMessageLoading({ key: "putPrisyncs" });
      const { data } = await Axios({
        url: `/api/v1/prisyncs/${id}.json`,
        data: {
          prisync,
          parent_id,
          related_ids,
        },
        method: "PUT",
      });
      // if (!data.success) throw new Error("ERR");
      antdAsyncMessageSuccess({ key: "putPrisyncs" });
      dispatch({
        type: "UPDATE_CUSTOM",
        payload: data,
      });
      return { success: true };
    } catch (err) {
      errorHandler(err);
      antdAsyncMessageError({ key: "putPrisyncs" });
      return {
        success: false,
        errors: buildErrorObject(err?.response?.data?.errors),
      };
    }
  };

export const putPrisyncProduct = (body) => async (dispatch) => {
  try {
    antdAsyncMessageLoading({ key: "putPrisyncProduct" });
    const { data } = await Axios({
      url: `/api/v1/prisyncs/${body.id}.json`,
      data: {
        prisync_product: body,
      },
      method: "put",
    });
    antdAsyncMessageSuccess({ key: "putPrisyncProduct" });
    console.log({ data });
    dispatch({
      type: "UPDATE_CUSTOM",
      payload: data,
    });
    return { success: true };
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key: "putPrisyncProduct" });
    return {
      success: false,
      errors: buildErrorObject(err?.response?.data?.errors),
    };
  }
};

export const prisyncCheckIfHaveDifference = async (params) => {
  try {
    antdAsyncMessageLoading({
      key: "prisyncCheckIfHaveDifference",
      text: "Check if have prices 15% difference",
    });
    const { data } = await Axios.post(
      `/api/v1/prisyncs/check_if_have_15_difference`,
      params
    );

    if (data.success) {
      antdAsyncMessageSuccess({
        key: "prisyncCheckIfHaveDifference",
      });
      return data;
    } else {
      antdAsyncMessageSuccess({
        key: "prisyncCheckIfHaveDifference",
      });
      return data;
    }
    throw new Error("ERR");
  } catch (err) {
    errorHandler(err);
    antdAsyncMessageError({ key: "prisyncCheckIfHaveDifference" });
    return false;
  }
};
